import { Inject, Injectable } from '@angular/core';
import { Dictionary, NgxFaviconConfig, NgxFaviconService, NgxFaviconUnknownFaviconError } from 'ngx-favicon';
import { DOCUMENT } from '@angular/common';
import { InjectionToken } from '@angular/core';
export const NGX_FAVICON_CONFIG: InjectionToken<NgxFaviconConfig<Dictionary<string>>> = new InjectionToken<
  NgxFaviconConfig<Dictionary<string>>
>('NGX_FAVICON_CONFIG');

@Injectable({
  providedIn: 'root'
})
export class FaviconService<CustomFavicon extends string> {
  constructor(
    private faviconService: NgxFaviconService<CustomFavicon>,
    @Inject(DOCUMENT) private document: Document,
    @Inject(NGX_FAVICON_CONFIG) private ngxFaviconConfig: NgxFaviconConfig<Dictionary<string>>
  ) {}

  public setCustomFavicon(faviconName: CustomFavicon) {
    this.faviconService.setCustomFavicon(faviconName);
    const pngFaviconName = `${faviconName as string}16` as CustomFavicon;
    this.setPNGCustomFavicon(pngFaviconName);
  }

  public setPNGFaviconByUrl(faviconUrl: string): void {
    if (!this.document) {
      return;
    }

    const linkElement: HTMLLinkElement = document.getElementById('faviconPng') as HTMLLinkElement;

    linkElement.type = 'image/png';
    linkElement.rel = 'icon';
    linkElement.href = faviconUrl;
  }

  public setPNGCustomFavicon(faviconName: CustomFavicon): void {
    if (!faviconName || !this.ngxFaviconConfig.custom[faviconName]) {
      throw new NgxFaviconUnknownFaviconError(faviconName);
    }

    this.updateFavicon(faviconName);
  }

  private updateFavicon(faviconName?: CustomFavicon): void {
    this.setPNGFaviconByUrl(this.ngxFaviconConfig.custom[faviconName] || this.ngxFaviconConfig.defaultUrl);
  }
}
